import { MemberDetailedInfo, User } from "@/types";

import { axios } from "../axios.instance";

export type GetUserRequest = {
  id: string;
};

export type GetUserResponse = Pick<User, "id" | "role"> & MemberDetailedInfo;

export const getUser = async (body: GetUserRequest): Promise<GetUserResponse> => {
  const { data } = await axios.get(`users/${body.id}`);

  return data;
};
